import
  React, {
  useContext,
  useEffect,
  useState
} from 'react';

import {
  useHistory,
  useLocation,
  useParams
} from 'react-router-dom';

import {
  Text,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  BackButton,
  Hero,
  PrimaryButton
} from 'components';

import {
  DrupalProvider
} from '../providers';

import {
  AppContext
} from '../context';

import {
  EmergencySMS
} from '../journeys';

import {
  getStorageWithExpiry,
  isEqual,
  useRedirectHandler
} from 'helpers';

import {
  HandleRender
} from 'hocs';

export const Single = () => {

  const location = useLocation();
  const history = useHistory();
  const { pillar, pillar_id } = useParams();
  const { device } = useContext(AppContext);

  const OS_NAME = device.getOSName();

  const [ state, setState ] = useState({
    item: location.state?.item || null,
    hideButton: location.state?.hideButton || false,
    config: null,
    isLoading: true,
    isError: false
  });

  const redirectHandler = useRedirectHandler();

  const getCachedData = async () => {

    if (pillar && pillar_id) {

      const cachedItem = await DrupalProvider.getCachedItem(`pillars--${pillar}`);

      if (cachedItem && cachedItem.ok && cachedItem.result) {

        const item = cachedItem.result.find(i => i.id === pillar_id);

        setState(prevState => ({
          ...prevState,
          isLoading: false,
          item: item
        }));

        if (item?.title.toLowerCase().includes('airtime') && item?.title.toLowerCase().includes('advance')) {

          window?.utag?.view({
            page_event: 'view',
            page_name: 'cbu: connectu: airtime advance: how it works',
            page_section: 'airtime advance',
            visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
            visitor_type: 'consumer',
            visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
          });
        }

        return;
      }
    }

    setState(prevState => ({
      ...prevState,
      isLoading: false,
      isError: !state.item
    }));
  };

  const renderCorrectUrl = () => {

    let link = location?.state?.item?.click_out_url?.uri;

    if (location?.state?.item?.android_link?.uri && location?.state?.item?.ios_link?.uri) {

      link = (isEqual(OS_NAME, 'iOS'))
        ? location?.state?.item?.ios_link?.uri
        : location?.state?.item?.android_link?.uri;
    }

    if (!link || location.state?.hideButton) {
      return;
    }

    return (
      <>
        <VContainerVH
          margin={'32px 0 75px'}>

          <PrimaryButton
            margin={'1.5em 1em 0'}
            text={'Take me there'}
            width={'85%'}
            onClick={() => {

              redirectHandler(
                history.location,
                `/redirect?targetUrl=${encodeURIComponent(link)}&` +
                `isZeroRated=${location.state.item.is_zero_rated}`,
                location.state.item.is_zero_rated
              );
            }}/>

        </VContainerVH>
      </>
    );
  };

  useEffect(() => {

    const init = async () => {

      await getCachedData();
    };

    init();

  }, []);

  const GenericPage = () => {

    return (

      <VFillContainer className={'single-page'}>
        {
          !!state.item &&
          <>

              <Hero
                background={`${Environment.current.drupalBaseUrl}${state.item?.image}`} />

              <BackButton
                onClick={() => history.goBack()} />

              <VFillContainer padding={'0 16px'} >

                <Text
                  padding={'0'}
                  fontSize={'20px'}
                  fontWeight={'bold'}>
                  {state.item?.title}
                </Text>

                <Text
                  dangerouslySetInnerHTML={
                    {
                      __html: state.item?.full_content || state.item?.full_content
                    }
                  } />
              </VFillContainer>

              { renderCorrectUrl() }
            </>
        }
      </VFillContainer>
    );
  };

  return (
    <HandleRender
      isLoading={state.isLoading}
      isError={state.isError}>

      { state.item?.title?.includes('Emergency SMS')

        ? <EmergencySMS
            item={state.item}/>

        : <GenericPage/>
      }

    </HandleRender>
  );
};
